import apiClient from './client'

export interface ProjectInterfaceBinding {
  device_instance_id: number
  device_position_label: string
  device_name: string
  specification_name: string | null
  interface_id: number
  interface_chassis_label: string
  interface_type_code: string
  interface_type_name: string
  schema_id: number
  schema_name: string
  
  binding_id: number | null
  network_id: number | null
  network_name: string | null
  network_code: string | null
  ip_last_octet: number | null
  mac_address: string | null
  note: string | null
  slave_id: number | null

  electrical_panel_id: number
  specification_id: number
  manufacturer: string | null
}

export interface SaveInterfaceBindingParams {
  device_instance_id: number
  interface_id: number
  network_id: number | null
  ip_last_octet?: number | null
  mac_address?: string | null
  note?: string | null
  slave_id?: number | null
}

export const getProjectInterfaces = async (projectId: number): Promise<ProjectInterfaceBinding[]> => {
  const response = await apiClient.get('/api/project_interfaces', {
    params: { project_id: projectId }
  })
  if (Array.isArray(response.data)) {
    return response.data
  }
  if (response?.data && response.data.success) {
    return response.data.data
  }
  throw new Error('Failed to fetch project interfaces')
}

export const saveInterfaceBinding = async (
  params: SaveInterfaceBindingParams
): Promise<{ binding_id: number }> => {
  const response = await apiClient.post('/api/project_interfaces', params)
  if (response && response.data && typeof response.data === 'object' && 'binding_id' in response.data) {
    return response.data as { binding_id: number }
  }
  if (response?.data && response.data.success) {
    return response.data.data
  }
  throw new Error('Failed to save interface binding')
}
